import { Col, Container, Row } from "react-bootstrap";
import logo from "../../assets/logo_white.png";
import up from "../../assets/up.png";
import { Link } from "react-router-dom";
import ScrollToTop from "../../hooks/ScrollToTop";
import * as ReactTranslated from "react-translated";
import pinMap from "../../assets/contact/pin.svg";

const Footer = () => {
  return (
    <Container fluid className="footer pt-5 pb-5">
      <Container>
        <Row>
          <Col md={1} xs={11} className="mx-auto pb-5">
            <img src={logo} className="img-fluid" />
          </Col>
          <Col md={2} xs={11} className="mx-auto">
            <ul className="list-unstyled">
              <li className="pb-2">
                <Link to="/projects" className="linkFooter main">
                  <b>
                    {" "}
                    <ReactTranslated.Translate text="menuOption1" />
                  </b>
                </Link>{" "}
              </li>
              <li className="pb-2">
                {" "}
                <Link to="/about" className="linkFooter main">
                  <b>
                    {" "}
                    <ReactTranslated.Translate text="menuOption2" />
                  </b>
                </Link>
              </li>
              <li className="pb-2">
                {" "}
                <Link to="/team" className="linkFooter main">
                  <b>
                    {" "}
                    <ReactTranslated.Translate text="menuOption3" />
                  </b>
                </Link>
              </li>

              <li className="pb-2">
                <Link to="/contact" className="linkFooter main">
                  <b>
                    {" "}
                    <ReactTranslated.Translate text="menuOption4" />
                  </b>
                </Link>
              </li>
            </ul>
          </Col>
          <Col md={2} xs={11} className="mx-auto">
            <Row>
              <Col md={12} xs={12}>
                <ul className="list-unstyled">
                  <li>
                    <b style={{ color: "#03caa6", fontWeight: "bold" }}>
                      {" "}
                      <ReactTranslated.Translate text="titleFollowUs" />
                    </b>
                  </li>
                  <li>
                    {" "}
                    <a
                      href="https://www.linkedin.com/company/wop/"
                      className="linkFooter"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Linkedin{" "}
                    </a>
                  </li>
                  <li>
                    {" "}
                    <a
                      href="https://www.instagram.com/wopba/"
                      className="linkFooter"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Instagram{" "}
                    </a>
                  </li>
                  <li>
                    {" "}
                    <a href="https://www.facebook.com/WopBA/" className="linkFooter" target={"_blank"} rel="noreferrer">
                      Facebook{" "}
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col md={12} xs={12}>
                <ul className="list-unstyled">
                  <li>
                    <b className="fw-bold " style={{ color: "#03caa6" }}>
                      {" "}
                      <ReactTranslated.Translate text="titleEmailUs" />
                    </b>
                  </li>
                  <li>
                    <a href="mailto:info@wopdigital.com.ar" className="linkFooter">
                      info@wopdigital.com.ar
                    </a>
                  </li>
                </ul>
              </Col>
              <Col md={6} xs={12}></Col>
            </Row>
          </Col>
          <Col md={4} xs={11} className="mx-auto">
            <Row>
              <Col md={12} xs={12}>
                <ul className="list-unstyled mb-0">
                  <li className="">
                    <b className="fw-bold" style={{ color: "#03caa6" }}>
                      <ReactTranslated.Translate text="titlefindUs" />
                    </b>
                  </li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col md={12} xs={12}>
                <ul className="list-unstyled">
                  <li>
                    <h6>
                      <img src={pinMap} alt="pin" className="img-fluid" /> Argentina - Buenos Aires
                    </h6>
                    Basavilbaso 1350 - Of. 603
                  </li>
                  <li>
                    <a
                      href="https://goo.gl/maps/yjkDZxsuR9Kx6bWZ6"
                      className="linkFooter"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <b className="fw-bold">Google Maps +</b>
                    </a>
                  </li>
                </ul>
              </Col>
              <Col md={12} xs={12}>
                <ul className="list-unstyled">
                  <li>
                    <h6>
                      <img src={pinMap} alt="pin" className="img-fluid" /> Ciudad de México - México
                    </h6>
                    José Maria Ibarrarán 72 piso 8,
                    <br /> Col San josé Insurgentes.
                  </li>
                </ul>
              </Col>
              <Col md={12} xs={12}>
                <ul className="list-unstyled">
                  <li>
                    <h6>
                      <img src={pinMap} alt="pin" className="img-fluid" /> Guadalajara - México
                    </h6>
                    Emeterio Robles Gil 241, <br /> Colonia Americana.
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end">
            <div>
              <a href="#top">
                <img src={up} className="img-fluid" />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Footer;
